import React from 'react';

const LoadingDots = () => {
  return (
    <div className="flex items-center gap-1.5 py-1">
      <div className="w-2.5 h-2.5 bg-primary/70 dark:bg-primary/80 rounded-full animate-bounce" style={{ animationDelay: '0ms', animationDuration: '1s' }}></div>
      <div className="w-2.5 h-2.5 bg-primary/70 dark:bg-primary/80 rounded-full animate-bounce" style={{ animationDelay: '150ms', animationDuration: '1s' }}></div>
      <div className="w-2.5 h-2.5 bg-primary/70 dark:bg-primary/80 rounded-full animate-bounce" style={{ animationDelay: '300ms', animationDuration: '1s' }}></div>
    </div>
  );
};

export default LoadingDots;
